// extracted by mini-css-extract-plugin
module.exports = {"rightChat":"_1VGU8","chatCon":"_2aeDz"};